// helper functions for use with JSON Web Tokens (JWT)
import config from 'shared/config';
import { AUTH_TOKEN, REFRESH_TOKEN } from './constants';

const TOKEN_KEY = 'jwt';

/**
 * Get a JSON Web Token (jwt) out of session storage.
 * @param {string} tokenType - default auth. Specify auth or refresh.
 * @return {string} jwt
 */
const getToken = (tokenType = AUTH_TOKEN) => {
	if (config.SET_ITEM_ENABLED) {
		return sessionStorage.getItem(`${TOKEN_KEY}/${tokenType}`);
	}
	if (config.JWTTOKEN !== undefined) {
		const tokenIndex = config.JWTTOKEN.findIndex(item => item.tokenType === tokenType);
		return tokenIndex !== -1 ? config.JWTTOKEN[tokenIndex].token : null;
	}
	return null;
};

/**
 * Delete a saved JSON Web Token (jwt) from session storage.
 * @param {string} tokenType - default null which deletes all. Can also specify auth or refresh.
 */
const removeToken = (tokenType = null) => {
	if (!tokenType) {
		if (config.SET_ITEM_ENABLED) {
			sessionStorage.removeItem(`${TOKEN_KEY}/${AUTH_TOKEN}`);
			sessionStorage.removeItem(`${TOKEN_KEY}/${REFRESH_TOKEN}`);
		} else if (config.JWTTOKEN !== undefined) {
			const authIndex = config.JWTTOKEN.findIndex(item => item.tokenType === AUTH_TOKEN);
			const refreshIndex = config.JWTTOKEN.findIndex(item => item.tokenType === REFRESH_TOKEN);
			if (authIndex !== -1) {
				config.JWTTOKEN.splice(authIndex);
			}
			if (refreshIndex !== -1) {
				config.JWTTOKEN.splice(refreshIndex);
			}
		}
	} else if (config.SET_ITEM_ENABLED) {
		sessionStorage.removeItem(`${TOKEN_KEY}/${tokenType}`);
	} else if (config.JWTTOKEN !== undefined) {
		const tokenIndex = config.JWTTOKEN.findIndex(item => item.tokenType === tokenType);
		if (tokenIndex !== -1) {
			config.JWTTOKEN.splice(tokenIndex);
		}
	}
};

/**
 * Save a JSON Web Token (jwt) in session storage.
 * @param {string} token - JWT
 * @param {string} tokenType - default auth. Specify auth or refresh.
 */
const saveToken = (token, tokenType = AUTH_TOKEN) => {
	if (config.SET_ITEM_ENABLED) {
		sessionStorage.setItem(`${TOKEN_KEY}/${tokenType}`, token);
	} else if (config.JWTTOKEN === undefined) {
		config.JWTTOKEN = [{ tokenType, token }];
	} else {
		const tokenIndex = config.JWTTOKEN.findIndex(item => item.tokenType === tokenType);
		if (tokenIndex !== -1) {
			config.JWTTOKEN[tokenIndex].token = token;
		} else {
			config.JWTTOKEN.push({ tokenType, token });
		}
	}
};

export { getToken, removeToken, saveToken };
